import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { ScopeOverviewActions } from '../store/actions/scope-overview.action'
import { ScopeOverviewTab } from '../enum/scope-overview-tab.enum'

@Injectable({ providedIn: 'root' })
export class ScopeOverviewNavigationService {
  currentTab: string

  constructor(
    private store$: Store,
    private router: Router
  ) {}

  selectTab(tab: string) {
    this.currentTab = tab
    const tabParam = tab != ScopeOverviewTab.SCOPE ? tab.toLowerCase().split(' ')[0] : null
    this.router.navigate([], { queryParams: { tab: tabParam } })
  }

  selectTabAndReload(tab: string, scopeId: number) {
    this.selectTab(tab)
    this.store$.dispatch(ScopeOverviewActions.getCurrentScope({ scopeId }))
  }
}
